<div class="container">
    <ul>
        @for (option of options; track option.value) {
            <li
                matRipple
                fxLayout="row"
                fxLayoutAlign="space-between center"
                (click)="handleSelectOption.emit(option)"
            >
                <span>{{ option.label }}</span>
                @if (value === option.value) {
                    <i class="fa-solid fa-check"></i>
                }
            </li>
        }
    </ul>
</div>
